import { useState } from 'react';
import { useSelector } from 'react-redux';

import { selectIosSafariRotated } from '../selectors/videoPlayer';
import { isIOSSafari } from '../utilities/device';

// On iOS Safari raw rotated media isn't displayed with the right rotation.
// To get around this, we wait until the media is transcoded before allowing
// the media to be played
export const useIosSafariRotatedMedia = () => {
  const [data, setData] = useState({
    isIosRotatedMedia: false,
    sourceUrlIsTranscoded: false,
  });

  const { sourceUrlIsTranscoded, mediaMetadataRotation } = useSelector(
    selectIosSafariRotated
  );

  const isIosRotatedMedia = mediaMetadataRotation && isIOSSafari;

  if (
    data.isIosRotatedMedia !== isIosRotatedMedia ||
    data.sourceUrlIsTranscoded !== sourceUrlIsTranscoded
  ) {
    setData({
      isIosRotatedMedia,
      sourceUrlIsTranscoded,
    });
  }

  return data;
};
